import script from "./product-list.vue?vue&type=script&setup=true&lang=js"
export * from "./product-list.vue?vue&type=script&setup=true&lang=js"

import "./product-list.vue?vue&type=style&index=0&id=745d21a1&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-745d21a1"]])

export default __exports__